import * as React from 'react';
const ServicesAggregationContext = React.createContext(null);
export function getServicesAggregation() {
    return React.useContext(ServicesAggregationContext);
}
const ServicesAggregationProvider = ({ children, userInfo, refetchUser }) => {
    return (React.createElement(ServicesAggregationContext.Provider, { value: { userInfo, refetchUser } }, children));
};
export default ServicesAggregationProvider;
